import styled from 'styled-components';

export const $Section = styled.section`
  width: 100%;
  min-width: 0;
  margin: 0 0 1.25rem;
  box-sizing: border-box;
`;

export const $SectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
`;

export const $SectionTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.fonts?.size?.medium ?? '1rem'};
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#111827'};
`;

export const $SectionCount = styled.span`
  font-size: ${({ theme }) => theme.fonts?.size?.ultraSmall ?? '0.75rem'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
`;

export const $CarouselViewport = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const $CarouselTrack = styled.div`
  display: flex;
  touch-action: pan-y pinch-zoom;
`;

export const $CarouselSlide = styled.div`
  flex: 0 0 88%;
  min-width: 0;
  padding-right: 0.75rem;
  box-sizing: border-box;
`;

export const $DocumentCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 11.5rem;
  padding: 0.9rem 1rem;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.newUI?.borders?.bigRadius ?? '12px'};
  border: 1px solid ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#e5e7eb'};
  background: ${({ theme }) =>
    theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
  box-shadow: ${({ theme }) =>
    (theme.newUI?.shadows as { level1?: string } | undefined)?.level1 ??
    '0 1px 3px rgba(0, 0, 0, 0.06)'};
`;

export const $DocumentPreview = styled.div<{ $extension: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5.5rem;
  border-radius: ${({ theme }) => theme.newUI?.borders?.mediumRadius ?? '8px'};
  background: ${({ $extension }) => {
    if ($extension === 'pdf') {
      return '#fef2f2';
    }

    if ($extension === 'xlsx') {
      return '#ecfdf5';
    }

    return '#eff6ff';
  }};
  color: ${({ $extension }) => {
    if ($extension === 'pdf') {
      return '#b91c1c';
    }

    if ($extension === 'xlsx') {
      return '#047857';
    }

    return '#1d4ed8';
  }};
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const $DocumentMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
`;

export const $DocumentName = styled.div`
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  font-weight: ${({ theme }) => theme.fonts?.weight?.mediumFont ?? 500};
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#111827'};
  word-break: break-word;
`;

export const $DocumentFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-top: auto;
  font-size: ${({ theme }) => theme.fonts?.size?.ultraSmall ?? '0.75rem'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
`;

export const $CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.75rem;
`;

export const $CarouselDot = styled.button<{ $isActive: boolean }>`
  width: ${({ $isActive }) => ($isActive ? '1rem' : '0.4rem')};
  height: 0.4rem;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: ${({ theme, $isActive }) =>
    $isActive
      ? (theme.colors?.primary ?? '#5369eb')
      : (theme.newUI?.variationColors?.light3 ?? '#cbd5e1')};
  cursor: pointer;
  transition:
    width 0.15s ease,
    background-color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }
`;

export const $EmptyState = styled.div`
  padding: 1rem;
  text-align: center;
  border: 1px dashed ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#cbd5e1'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.mediumRadius ?? '8px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  background: ${({ theme }) => theme.newUI?.variationColors?.light5 ?? '#f8fafc'};
`;
